export function videoStatusPollInterval(query) {
  if ([401, 403, 404].includes(query.state.error?.status)) return false;
  const unresolved = (query.state.data?.classes || []).filter(lesson => {
    const key = lesson.video?.key || lesson.recording?.finalVideo?.key;
    return lesson.recording?.status === "merging" || (key &&
      (lesson.hls?.status !== "ready" || lesson.hls.sourceKey !== key));
  });
  if (!unresolved.length) return false;
  // Failed jobs may retry; keep checking less frequently when no job is processing.
  return unresolved.every(lesson => lesson.hls?.status === "failed") ? 30000 : 10000;
}
